import { ReactNode } from 'react';
import styles from './Toolbar.module.scss';
import { IntlErrorBoundary } from '_common/components';

type ToolbarProps = {
  id?: string;
  children: ReactNode;
};

const Toolbar = ({ id, children }: ToolbarProps) => {
  return (
    <div className={styles.toolbar} id={id}>
      <IntlErrorBoundary size="s">{children}</IntlErrorBoundary>
    </div>
  );
};

const Left = ({ children }: { children: ReactNode }) => {
  return <div className={styles.left}>{children}</div>;
};
const MiddleLeft = ({ children }: { children: ReactNode }) => {
  return <div className={styles.middleleft}>{children}</div>;
};
const Middle = ({ children }: { children: ReactNode }) => {
  return <div className={styles.middle}>{children}</div>;
};
const MiddleRight = ({ children }: { children: ReactNode }) => {
  return <div className={styles.middleright}>{children}</div>;
};
const Right = ({ children }: { children: ReactNode }) => {
  return <div className={styles.right}>{children}</div>;
};

export default Object.assign(Toolbar, {
  Left,
  MiddleLeft,
  Middle,
  MiddleRight,
  Right,
});
